import { useLayoutEffect, useState, type RefObject } from "react";

// Rendered height of a DOM element, kept current through a ResizeObserver
// (catches late web-font loads and zoom, which fire no resize event).
export function useElementHeight(ref: RefObject<HTMLElement | null>): number {
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setHeight(el.getBoundingClientRect().height);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return height;
}
